import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { AboutSection } from '../components/sections/AboutSection';
import { HowItWorks } from '../components/sections/HowItWorks';
import { site } from '../data/site';
export function About() {
  return <>
      <PageHeader eyebrow="About Us" title="A digital publishing business built for a global audience" description={`${site.brandName} is operated by ${site.legalEntity}, a Wyoming limited liability company conducting business online with digital-only products.`} data-id="element-190" data-mp="29hsmjxuvn67w" />
      <AboutSection data-id="element-191" data-mp="3751cq65tp3g8" />
      <HowItWorks data-id="element-192" data-mp="2sad9kynwah3s" />
      <section className="w-full bg-white" data-id="element-193" data-mp="2sawm1zus0daf">
        <div className="mx-auto max-w-content px-6 py-20" data-id="element-194" data-mp="2sc7krl9d6uuo">
          <div className="grid gap-10 rounded-2xl border border-navy-100 p-8 sm:p-10 md:grid-cols-3" data-id="element-195" data-mp="2x86i3yco7n78">
            <div data-id="element-196" data-mp="1gtwvp9rzo8j1">
              <h2 className="text-sm font-semibold uppercase tracking-widest text-navy-400" data-id="element-197" data-mp="1gteqhnncmjyz">
                Business model
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-navy-600" data-id="element-198" data-mp="1uhid1a4d6c3j">
                We create digital content in-house and sell it directly to
                customers through secure online checkout. Every order is
                fulfilled electronically.
              </p>
            </div>
            <div data-id="element-199" data-mp="1yjn5i5j2t2ol">
              <h2 className="text-sm font-semibold uppercase tracking-widest text-navy-400" data-id="element-200" data-mp="1yj3xbgj89snr">
                Legal operator
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-navy-600" data-id="element-201" data-mp="2dete909k3flm">
                {site.legalEntity}, a limited liability company registered in{' '}
                {site.jurisdiction}, operating the {site.brandName} brand at{' '}
                {site.domain}.
              </p>
            </div>
            <div data-id="element-202" data-mp="2i9h3j1cdwe19">
              <h2 className="text-sm font-semibold uppercase tracking-widest text-navy-400" data-id="element-203" data-mp="2w75bj8lcrqow">
                Customer support
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-navy-600" data-id="element-204" data-mp="2r93t8pvr3veh">
                Support is provided by email at{' '}
                <a href={`mailto:${site.supportEmail}`} className="font-medium text-brand-indigo hover:text-brand-violet" data-id="element-205" data-mp="1owhbtcdhjkrs">
                  {site.supportEmail}
                </a>
                , typically within 1–2 business days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}